type ConfigurationErrorScreenProps = {
  errors: string[];
  runtimeEnvApplied?: boolean;
};

export const ConfigurationErrorScreen = ({ errors, runtimeEnvApplied }: ConfigurationErrorScreenProps) => {
  const uniqueErrors = Array.from(new Set(errors.filter(Boolean)));

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 px-6 text-slate-100">
      <div className="max-w-xl rounded-2xl border border-slate-800 bg-slate-900/60 p-8 shadow-2xl shadow-slate-900/50">
        <div className="mb-4 text-center">
          <p className="text-sm uppercase tracking-[0.2em] text-sky-400">Configuration required</p>
          <h1 className="text-2xl font-semibold text-white">Rack and Role is not configured</h1>
        </div>
        <p className="mb-4 text-slate-200">
          We couldn&apos;t find the Supabase connection settings this app needs. Please provide your environment
          variables via <code className="rounded bg-slate-800 px-1 py-0.5 text-sky-300">runtime-config.js</code> or the
          <code className="mx-1 rounded bg-slate-800 px-1 py-0.5 text-sky-300">VITE_*</code> public env vars before
          rebuilding.
        </p>

        {uniqueErrors.length > 0 ? (
          <div className="mb-4 rounded-lg border border-amber-500/40 bg-amber-500/10 p-4 text-amber-100">
            <p className="font-medium text-amber-200">What&apos;s missing?</p>
            <ul className="list-disc space-y-1 pl-5">
              {uniqueErrors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="mb-4 rounded-lg border border-slate-800 bg-slate-900 p-3 text-slate-200">
            <p>No specific errors were detected, but Supabase credentials are not available.</p>
          </div>
        )}

        <div className="space-y-2 text-sm text-slate-300">
          <p className="font-medium text-slate-100">How to fix</p>
          <ul className="list-disc space-y-1 pl-5">
            <li>
              Ensure <code className="rounded bg-slate-800 px-1 py-0.5 text-sky-300">runtime-config.js</code> is served
              with <code className="rounded bg-slate-800 px-1 py-0.5 text-sky-300">VITE_SUPABASE_URL</code> and{" "}
              <code className="rounded bg-slate-800 px-1 py-0.5 text-sky-300">VITE_SUPABASE_PUBLISHABLE_KEY</code>.
            </li>
            <li>Confirm your deployment environment injects the same values at build time if runtime config is absent.</li>
            {!runtimeEnvApplied && (
              <li>
                The runtime configuration object <code className="rounded bg-slate-800 px-1 py-0.5 text-sky-300">
                  window.__RACKANDROLE_PUBLIC_ENV__
                </code>{" "}
                was not detected.
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationErrorScreen;
